import React from 'react';
import { Divider, Drawer, Typography } from 'antd';
import type { TaskHistoryItem } from '../../types/taskHistory';
import {
  formatTaskHistoryDateTime,
  formatTaskHistoryExecutor
} from '../../utils/taskHistoryPresentation';
import TaskCategoryBadge from './TaskCategoryBadge';
import TaskHistoryObjectLink from './TaskHistoryObjectLink';
import TaskStatusBadge, { resolveTaskHistoryDisplayStatus } from './TaskStatusBadge';
import './taskHistoryDetail.css';

const { Title, Text } = Typography;

export interface TaskHistoryDetailDrawerProps {
  item: TaskHistoryItem | null;
  open: boolean;
  onClose: () => void;
}

function DetailField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="task-history-detail__field">
      <Text className="task-history-detail__label">{label}</Text>
      <div className="task-history-detail__value">{children}</div>
    </div>
  );
}

const TaskHistoryDetailDrawer: React.FC<TaskHistoryDetailDrawerProps> = ({
  item,
  open,
  onClose
}) => {
  return (
    <Drawer
      title="Подробности задачи"
      open={open}
      onClose={onClose}
      width={480}
      destroyOnClose
    >
      {item ? (
        <div className="task-history-detail">
          <Title level={4} className="task-history-detail__title">
            {item.taskTypeLabel}
          </Title>
          <Divider className="task-history-detail__divider" />

          <div className="task-history-detail__fields">
            <DetailField label="Статус">
              <TaskStatusBadge status={resolveTaskHistoryDisplayStatus(item)} />
            </DetailField>
            <DetailField label="Дата создания">
              {formatTaskHistoryDateTime(item.createdAt)}
            </DetailField>
            <DetailField label="Дата выполнения">
              {formatTaskHistoryDateTime(item.completedAt)}
            </DetailField>
            <DetailField label="Исполнитель">
              {formatTaskHistoryExecutor(item.completedByUserName)}
            </DetailField>
            <DetailField label="Объект">
              <TaskHistoryObjectLink item={item} />
            </DetailField>
            <DetailField label="Тип задачи">
              <TaskCategoryBadge category={item.taskCategory} label={item.taskCategoryLabel} />
            </DetailField>
            <DetailField label="Длительность">
              {item.durationFormatted || item.durationLabel || '—'}
            </DetailField>
            <DetailField label="Комментарии">{item.comment?.trim() || '—'}</DetailField>
          </div>

          {/* Reserved for future sections: attachments, photos, finance links, change log */}
          <div className="task-history-detail__extensions" aria-hidden="true" />
        </div>
      ) : null}
    </Drawer>
  );
};

export default TaskHistoryDetailDrawer;
